import React, { useEffect } from "react";
import { getTokenInfo } from "../../../utils/Guard";
import styles from "./MyCourses.module.css";
import { DataView, DataViewLayoutOptions } from "primereact/dataview";
import { useState } from "react";
import { Button } from "primereact/button";
import { classNames } from "primereact/utils";
import { Card } from "primereact/card";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { GetCategories } from "../../../store/categories-store/categories-actions";
import { GetCourses } from "../../../store/course-store/course-actions";
import { GetUserById } from "../../../store/auth-store/auth-actions";
import Loading from "../../../components/loading/Loading";

const MyCourses = () => {
  const userInfo = getTokenInfo();
  const navigate = useNavigate();
  // const courses = useSelector((state) => state.course.courses);
  const notification = useSelector((state) => state.ui.notification);
  const user = useSelector((state) => state.auth.auth.ordens);
  const orders = useSelector((state) => state.auth.auth.ordens);
  const categories = useSelector((state) => state.category.categories);
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(true);
  const [isWideScreen, setIsWideScreen] = useState(window.innerWidth > 1024);
  const [isTablet, setIsTablet] = useState(window.innerWidth > 1200);
  const [isMobile, setIsMobile] = useState(window.innerWidth > 480)

  const userCourses = orders.filter(
    (order) => order.status.id === 2 && order.course.id > 0
  );

  const courses = userCourses.map((order) => order.course);

  useEffect(() => {
      const handleResize = () => {
        setIsWideScreen(window.innerWidth > 1200);
      };
  
      window.addEventListener("resize", handleResize);
  
      handleResize();
  
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, []);
  
    useEffect(() => {
      const handleResize = () => {
        setIsTablet(window.innerWidth < 1200);
      };
  
      window.addEventListener("resize", handleResize);
  
      handleResize();
  
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, []);
  
    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth < 520);
      };
  
      window.addEventListener("resize", handleResize);
  
      handleResize();
  
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, []);

  useEffect(() => {
    if (
      (userInfo !== undefined &&
        userInfo !== null &&
        userInfo.UserId !== undefined &&
        userInfo.UserId !== null &&
        user.name === "") ||
      user.length === 0
    ) {
      dispatch(GetUserById(userInfo.UserId, userInfo.Email, null, true));
    }
  }, [dispatch, user, userInfo]);

  useEffect(() => {
    if (
      userInfo === undefined ||
      userInfo === null ||
      userInfo.UserId === undefined ||
      userInfo.UserId === null ||
      userInfo.UserId === ""
    ) {
      window.location.href = "/";
    }
  }, [userInfo]);

  useEffect(() => {
    if (
      categories !== null &&
      categories !== undefined &&
      categories.length === 0
    ) {
      dispatch(GetCategories("jmiranda@aba.org.do", false));
    }
  }, [categories]);

  useEffect(() => {
    if (courses !== null && courses !== undefined && courses.length === 0) {
      setIsLoading(true);
      dispatch(GetCourses("jmiranda@aba.org.do", userInfo.UserId, true));
    }
  }, [courses.length]);

  useEffect(() => {
    if (
      notification !== null &&
      notification !== undefined &&
      notification.status !== undefined &&
      notification.status === "success"
    ) {
      setTimeout(function () {
        setIsLoading(false);
      }, 10500);
    }
  }, [notification]);

  const [layout, setLayout] = useState("grid");

  const listItem = (course, index) => {
    return (
      <div onClick={() => {
        window.location.href = `/courseinfo/${course.id}`;
      }} className="col-12" key={course.id}>
        <div
          className={classNames(
            "flex flex-column xl:flex-row xl:align-items-start p-4 gap-4",
            { "border-top-1 surface-border": index !== 0 }
          )}
        >
          <img
            className="w-9 sm:w-16rem xl:w-10rem shadow-2 block xl:block mx-auto border-round"
            src={course.imageUrl}
            alt={course.topic}
          />
          <div className="flex flex-column sm:flex-row justify-content-between align-items-center xl:align-items-start flex-1 gap-4">
            <div className="flex flex-column align-items-center sm:align-items-start gap-3">
              <div className="text-2xl font-bold text-900">{course.topic}</div>

              <div className="flex align-items-center gap-3">
                <p className={styles.cardDescription}>
                  {formatTextList(course.shortDescription)}
                </p>
                <span className="flex align-items-center gap-2"></span>
              </div>
            </div>
            <div className="flex sm:flex-column align-items-center sm:align-items-end gap-3 sm:gap-2" style={isWideScreen || isMobile || isTablet ? { } : { marginLeft: "50vw", marginTop: "10vh" }}>
              <Button
                icon="pi pi-chevron-right"
                className="p-button-rounded"
                onClick={() => {
                  window.location.href = `/courseinfo/${course.id}`;
                }}
              ></Button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const formatText = (text) => {
    const maxLength = 103;

    if (text.length > maxLength) {
      return text.substring(0, maxLength - 3) + "...";
    }

    return text;
  };

  const formatTextList = (text) => {
    const maxLength = 150;

    if (text.length > maxLength) {
      return text.substring(0, maxLength - 3) + "...";
    }

    return text;
  };

  const cardHeader = (img) => {
    return (
      <div className={styles.cardHeaderContainer}>
        <img alt="Card" src={img} className={styles.cardHeader} />
      </div>
    );
  };

  const cardFooter = (course) => {
    return <span className={styles.cardFooter}>
      {/* US${course.price} */}
      </span>;
  };
  const gridItem = (course) => {
    return (
      <Card
        title={course.topic}
        subTitle={
          <span className={styles.cardSubtitle}>
            {course.courseCategory.category}
          </span>
        }
        className={styles.cardGridItem}
        header={cardHeader(course.imageUrl)}
        footer={cardFooter(course)}
        emptyMessage="No se encontró ningún curso."
        onClick={() => {
          window.location.href = `/courseinfo/${course.id}`;
        }}
      >
        <p className={styles.cardDescription}>
          {formatText(course.shortDescription)}
        </p>
      </Card>
    );
  };

  const itemTemplate = (course, layout, index) => {
    if (!course) {
      return;
    }

    if (layout === "list" || !isWideScreen) return listItem(course, index);
    else if (layout === "grid") return gridItem(course);
  };

  const listTemplate = (courses, layout) => {
    return (
      <div className="grid grid-nogutter">
        {courses.map((course, index) => itemTemplate(course, layout, index))}
      </div>
    );
  };

  const header = () => {
    return (
      <div style={{ display: "flex", marginTop: "5%" }}>
        <h1 className={styles.headerTitle}>Mis cursos</h1>
        <div className="flex">
        {isWideScreen && (
          <DataViewLayoutOptions
            layout={layout}
            onChange={(e) => setLayout(e.value)}
            className={styles.layoutOptions}
          />
        )}
        </div>
      </div>
    );
  };

  if (isLoading) {
    return <Loading />;
  }

  return (
    <>
      {!isLoading && courses.length > 0 ? (
        <div className={styles.dataViewContainer}>
          <DataView
            value={courses}
            listTemplate={listTemplate}
            layout={layout}
            header={header()}
            paginator
            rows={8}
          />
        </div>
      ) : (
        <div
          style={{
            textAlign: "center",
            width: "100%",
            height: "100vh",
            alignContent: "center",
            marginTop: "3%",
          }}
        >
          <h1 className={styles.emptyMessage}>
            Todavía no has comprado ningún curso
          </h1>
          <button
            onClick={() => navigate("/courses/none")}
            className={styles.button}
          >
            Ver cursos disponibles
          </button>
        </div>
      )}
    </>
  );
};

export default MyCourses;
